export const currencies = [
  { value: 'USD', label: 'USD' },
  // { value: 'EUR', label: 'EUR' },
  // { value: 'COP', label: 'COP' },
  // { value: 'MXN', label: 'MXN' }
];
